<template>
  <div class="wrapper" :class="[{ 'nav-open': $sidebar.showSidebar }, { rtl: $route.meta.rtlActive }]">
    <notifications></notifications>
    <side-bar :active-color="sidebarBackground" :background-image="sidebarBackgroundImage" :data-background-color="sidebarBackgroundColor">
      <!-- <user-menu :title="user.firstName"></user-menu> -->
      <!-- <mobile-menu></mobile-menu> -->
      <template slot="links">
        <!-- Die Dashboard-ROUTE bleibt bewusst ungeschuetzt: der Route-Guard leitet bei fehlendem Recht
             auf /app/dashboard um, ein rechtepflichtiges Dashboard erzeugte eine Weiterleitungsschleife. -->
        <sidebar-item v-if="canView('Dashboard')" :link="{ name: $t('layout.dashboard'), icon: 'dashboard', path: '/app/dashboard' }"></sidebar-item>
        <sidebar-item
          v-if="canView('ProcurementDashboard') || canView('Procurement') || canView('ShippingPlans')"
          :link="{ name: $t('layout.procurement.procurement'), disableCollapse: true, icon: 'add_shopping_cart', iconOutlined: true }"
        >
          <sidebar-item v-if="canView('ProcurementDashboard')" :link="{ name: $t('layout.procurement.dashboard'), icon: 'dashboard', path: '/app/procurement-dashboard' }" />
          <sidebar-item v-if="canView('Procurement')" :link="{ name: $t('layout.procurement.procurement'), icon: 'add_shopping_cart', iconOutlined: true, path: '/app/procurement' }" />
          <sidebar-item v-if="canView('ShippingPlans')" :link="{ name: $t('layout.shippingPlans'), icon: 'local_shipping', path: '/app/shipping-plans' }" />
        </sidebar-item>
        <sidebar-item v-if="canView('Products')" :link="{ name: $t('layout.products'), icon: 'package_2', iconOutlined: true, path: '/app/products' }"> </sidebar-item>
        <sidebar-item
          v-if="canView('Orders') || canView('RulesSqp') || canView('StreetDirectory')"
          :link="{ name: $t('layout.orders'), disableCollapse: true, icon: 'grade', iconOutlined: false }"
        >
          <sidebar-item v-if="canView('Orders')" :link="{ name: $t('layout.orders'), icon: 'grade', iconOutlined: false, path: '/app/orders' }"> </sidebar-item>
          <sidebar-item v-if="canView('RulesSqp')" :link="{ name: $t('layout.rulesSQP'), icon: 'conveyor_belt', iconOutlined: false, path: '/app/rules-sqp' }"> </sidebar-item>
          <sidebar-item v-if="canView('StreetDirectory')" :link="{ name: $t('layout.streetDirectory'), icon: 'signpost', iconOutlined: false, path: '/app/street-directory' }"> </sidebar-item>
        </sidebar-item>

        <sidebar-item
          v-if="canView('Suppliers')"
          :link="{
            name: $t('layout.suppliers'),
            icon: 'precision_manufacturing',
            iconOutlined: true,
            path: '/app/suppliers',
          }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="canView('WmsDashboard') || canView('Inventories') || canView('Warehouses') || canView('StorageLocations') || canView('InventoryManagementExport') || canView('WarehousesHistory')"
          :link="{ name: $t('layout.wms.wms'), disableCollapse: true, icon: 'warehouse' }"
        >
          <sidebar-item v-if="canView('WmsDashboard')" :link="{ name: $t('layout.wms.dashboard'), icon: 'dashboard', path: '/app/wms-dashboard' }" />
          <sidebar-item v-if="canView('Inventories')" :link="{ name: $t('layout.wms.inventory'), icon: 'inventory_2', path: '/app/wms-inventories' }" />
          <sidebar-item v-if="canView('Warehouses')" :link="{ name: $t('layout.wms.warehouses'), icon: 'shelves', path: '/app/wms-warehouses' }" />
          <sidebar-item
            v-if="canView('StorageLocations')"
            :link="{
              name: $t('layout.wms.storagelocations'),
              icon: 'home_storage',
              iconOutlined: true,
              path: '/app/wms-storage-locations',
            }"
          />
          <sidebar-item
            v-if="canView('InventoryManagementExport')"
            :link="{
              name: $t('layout.wms.fileExplorer'),
              icon: 'download',
              iconOutlined: false,
              path: '/app/wms-management-export',
            }"
          />
          <sidebar-item
            v-if="canView('WarehousesHistory')"
            :link="{
              name: $t('layout.wms.history'),
              icon: 'history',
              path: '/app/wms-history',
            }"
          />
        </sidebar-item>
        <sidebar-item v-if="isAdminUser" :link="{ name: $t('layout.users'), icon: 'people', path: '/app/users' }"></sidebar-item>
      </template>
      <template slot="bottom">
        <ul class="nav sidebar-bottom-nav">
          <li class="sidebar-bottom-item">
            <drop-down direction="up">
              <template slot="title">
                <a class="nav-link" href="javascript:void(0)">
                  <i class="material-icons">language</i>
                  <p class="sidebar-normal">{{ languageName }}</p>
                </a>
              </template>
              <ul class="dropdown-menu">
                <li><a @click.prevent="setLanguage('de')" href="#">Deutsch</a></li>
                <li><a @click.prevent="setLanguage('en')" href="#">English</a></li>
              </ul>
            </drop-down>
          </li>
          <li class="sidebar-bottom-item">
            <a class="nav-link" href="javascript:void(0)" @click="logout">
              <i class="material-icons">logout</i>
              <p class="sidebar-normal">{{ $t("layout.logout") }}</p>
            </a>
          </li>
        </ul>
      </template>
    </side-bar>
    <div class="main-panel">
      <div :class="{ content: !$route.meta.hideContent }" @click="toggleSidebar">
        <zoom-center-transition :duration="200" mode="out-in">
          <router-view></router-view>
        </zoom-center-transition>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
// import PerfectScrollbar from "perfect-scrollbar";
// import "perfect-scrollbar/css/perfect-scrollbar.css";

import { ZoomCenterTransition } from "vue2-transitions";
import { isAdmin, canView } from "@/mixins/auth";
import TokenService, { LANGUAGE_SELECTED } from "../../../services/token.service";
import { EventBus } from "@/helpers/event-bus";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  // if (hasElement(className)) {
  //   new PerfectScrollbar(`.${className}`, { wheelSpeed: 0.09 });
  //   document.getElementsByClassName(className)[0].scrollTop = 0;
  // } else {
  //   // try to init it later in case this component is loaded async
  //   setTimeout(() => {
  //     initScrollbar(className);
  //   }, 100);
  // }
}

function reinitScrollbar() {
  // let docClasses = document.body.classList;
  // let isWindows = navigator.platform.startsWith("Win");
  // if (isWindows) {
  //   // if we are on windows OS we activate the perfectScrollbar function
  //   initScrollbar("sidebar");
  //   initScrollbar("sidebar-wrapper");
  //   initScrollbar("main-panel");
  //   docClasses.add("perfect-scrollbar-on");
  // } else {
  //   docClasses.add("perfect-scrollbar-off");
  // }
}

export default {
  components: {
    ZoomCenterTransition,
  },
  data() {
    return {
      sidebarBackgroundColor: "black",
      sidebarBackground: "green",
      sidebarBackgroundImage: "/img/sidebar-2.jpg",
      sidebarMini: true,
      sidebarImg: true,
      user: TokenService.getUser(),
    };
  },
  computed: {
    isAdminUser() {
      return isAdmin();
    },
    languageName() {
      return this.$i18n.locale === "en" ? "English" : "Deutsch";
    },
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
    canView(menu) {
      return isAdmin() || canView(menu);
    },
    logout() {
      this.$store.dispatch("auth/logoutUser").finally(() => {
        this.$router.replace("/login");
      });
    },
    setLanguage(locale) {
      this.$i18n.locale = locale;
      TokenService.set(LANGUAGE_SELECTED, locale);
      document.documentElement.lang = locale;
      EventBus.$emit("language:changed", { locale });
    },
  },
  updated() {
    reinitScrollbar();
  },
  mounted() {
    reinitScrollbar();
    EventBus.$on("scroll:changed", () => {
      reinitScrollbar();
    });
  },
  unmounted() {
    EventBus.$off("scrollbar:changed");
  },
  watch: {
    sidebarMini() {
      this.minimizeSidebar();
    },
  },
};
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}
.main-panel .zoomIn {
  animation-name: zoomIn95;
}
@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.main-panel .zoomOut {
  animation-name: zoomOut95;
}

.sidebar .nav .nav {
  padding-left: 15px;
}
.sidebar .logo:after {
  background-color: rgba(255, 255, 255, 0.3) !important;
}
.sidebar-bottom-nav {
  list-style: none;
  padding: 0;
  margin: 0;
  padding-top: 8px;
  position: relative;
}
.sidebar-bottom-nav:before {
  content: "";
  position: absolute;
  top: 0;
  right: 15px;
  height: 1px;
  width: calc(100% - 30px);
  background-color: rgba(255, 255, 255, 0.3);
}
.sidebar .sidebar-wrapper {
  overflow-y: auto !important;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.3) transparent;
}
.sidebar .sidebar-wrapper::-webkit-scrollbar {
  width: 6px;
}
.sidebar .sidebar-wrapper::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 3px;
}
.sidebar .sidebar-wrapper::-webkit-scrollbar-track {
  background: transparent;
}
.sidebar-bottom-item .dropdown-menu li a {
  color: #333 !important;
}
.sidebar-bottom-item .dropdown-menu li a:hover {
  color: #000 !important;
  background-color: #f5f5f5 !important;
}
.sidebar-bottom-item > a.nav-link,
.sidebar-bottom-item .nav-link {
  display: flex;
  align-items: center;
  padding: 8px 15px;
  cursor: pointer;
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
}
.sidebar-bottom-item > a.nav-link:hover,
.sidebar-bottom-item .nav-link:hover {
  color: #fff;
}
.sidebar-bottom-item .material-icons {
  font-size: 24px;
  margin-right: 10px;
  width: 30px;
  text-align: center;
}
.sidebar-bottom-item .sidebar-normal {
  margin: 0;
  font-size: 14px;
  white-space: nowrap;
  color: rgba(255, 255, 255, 0.8);
  opacity: 1;
  transform: translateX(0px);
  transition: opacity 0.3s ease, transform 0.3s ease;
}
.sidebar-mini .sidebar-bottom-item .sidebar-normal {
  opacity: 0;
  transform: translateX(-25px);
  pointer-events: none;
}
.sidebar-mini .sidebar:hover .sidebar-bottom-item .sidebar-normal {
  opacity: 1;
  transform: translateX(0px);
  pointer-events: auto;
}
.sidebar-bottom-item .dropdown-menu {
  left: 60px !important;
  bottom: 0 !important;
  top: auto !important;
}
.sidebar-bottom-item .dropup .dropdown-menu {
  bottom: 40px !important;
}
</style>
